module.exports = __webpack_public_path__ + "static/31-FLEXIBLE-WORKING-REGULATIONS-8470c9d74455f4742045982537f42392.jpg";